// extracted by mini-css-extract-plugin
export var colorSquare = "_p4-0";
export var danger = "_p4-5";
export var lightPink = "_p4-8";
export var neutralBlue = "_p4-7";
export var neutralYellow = "_p4-6";
export var normal = "_p4-1";
export var primary = "_p4-2";
export var primaryLight = "_p4-3";
export var solidBlack = "_p4-g";
export var solidGreen = "_p4-b";
export var solidLightBlue = "_p4-d";
export var solidNavy = "_p4-c";
export var solidOrange = "_p4-f";
export var solidPink = "_p4-e";
export var solidRed = "_p4-9";
export var solidYellow = "_p4-a";
export var success = "_p4-4";